
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mint-burn",
      function () {
        return require("private-next-pages/mint-burn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mint-burn"])
      });
    }
  